import { Code2, GitBranch, Server } from 'lucide-react'

import { LandingPageData } from '../../components/landing/landing-page'
import profileImage from '../profile.jpg'
import { resume } from '../resume/en'

export const landing: LandingPageData = {
  profile: {
    name: resume.introduction.name,
    image: profileImage,
  },
  contacts: {
    overline: 'Ready to ship?',
    headline:
      'Whether you need a Lead Developer to drive a project or an Architecture Review to unblock your team, let’s talk.',
    email: resume.contacts.email,
    phone: resume.contacts.phone,
  },
  hero: {
    headline: 'Architect that speaks the language of business.',
    description:
      'Turning complex requirements into stable, production-ready software. I combine deep backend and frontend expertise with a DevOps mindset to deliver solutions that actually serve the business.',
  },
  philosophy: {
    headline: 'From Process to Production',
    overline: 'Process • Dev • Ops',
    claims: [
      {
        title: 'Design the Process',
        description:
          'Using BPMN and Camunda to ensure the technical solution matches the business reality.',
        icon: GitBranch,
      },
      {
        title: 'Build the Core',
        description:
          'Full-stack development (Java, React, Angular) focused on stability and long-term maintainability.',
        icon: Code2,
      },
      {
        title: 'Automate the Run',
        description:
          "Applying a System Engineer’s mindset to CI/CD and IaC so the business isn't slowed down by manual Ops.",
        icon: Server,
      },
    ],
  },
  outcomes: {
    headline: 'Proven Outcomes',
    overline: 'Role • Industry',
    outcomes: [
      {
        industry: 'Government Agency',
        role: 'Lead Developer',
        description:
          'Automated over 50,000 monthly transactions by digitalizing manual workflows into executable Camunda processes.',
      },
      {
        industry: 'Digital Rights Management',
        role: 'Frontend Architect',
        description:
          'Unified Component Library & Design System (Angular/Nx) to standardize UI across multiple enterprise apps.',
      },
      {
        industry: 'Life Insurance',
        role: 'DevOps Engineer',
        description:
          'Guaranteed environment parity across 6 stages by converting infrastructure to Terraform and Gitops, eliminating manual configuration drift and release-day errors.',
      },
    ],
  },
  services: {
    headline: 'How I Can Help',
    overline: 'Contracting • Consulting',
    offers: [
      {
        headline: 'Development & Architecture',
        overline: 'Contracting',
        bullets: [
          'Lead Developer for Enterprise Projects.',
          'Implementation from Architecture to Deployment.',
          'Legacy Modernization & Cloud Migration.',
        ],
      },
      {
        headline: 'Architecture & DevOps Reviews',
        overline: 'Consulting',
        bullets: [
          'One-off audits of your current stack and workflow.',
          'Scalability assessments and security best practices.',
          'Health Check for your Camunda/BPMN implementation.',
        ],
      },
    ],
  },
  technologies: {
    headline: 'My Toolbox',
    overline: 'Backend • Frontend • DevOps',
    items: [
      'Java',
      'Kotlin',
      'Spring Boot',
      'Camunda (BPMN/DMN)',
      'React',
      'Angular',
      'Vue',
      'Kubernetes',
      'Terraform',
      'AWS',
      'GCP',
      'OpenShift',
      'ArgoCD',
      'Docker',
      'PostgreSQL',
    ],
  },
}
